/* eslint-disable */
// THIS FILE IS GENERATED. DO NOT EDIT. Edits should be made in 'phone-number.scss' instead.
import { css } from 'lit';
export default css `:host{white-space:nowrap}@media (min-width:768px){.mobileonly{display:none}}`;
//# sourceMappingURL=phone-number.scss.js.map